import { useEffect, useState } from "react";
import { TOOLS } from "@/data/tools";

const KEY = "sap:started";
export const FILLABLE = TOOLS.filter((t) => t.id !== "resource-directory");

const sectionFor = (key) => (key === "parent-letters" ? "parent-partnership" : FILLABLE.find((t) => key.startsWith(t.id))?.id);

export const getStarted = () => {
  try {
    const s = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(s) ? s : [];
  } catch {
    return [];
  }
};

const save = (list) => {
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event("sap:progress"));
};

export const markStarted = (key) => {
  const id = sectionFor(key);
  if (!id) return;
  const s = getStarted();
  if (!s.includes(id)) save([...s, id]);
};

export const unmarkStarted = (id) => save(getStarted().filter((x) => x !== id));

export const useProgress = () => {
  const [started, setStarted] = useState(getStarted);
  useEffect(() => {
    const f = () => setStarted(getStarted());
    window.addEventListener("sap:progress", f);
    return () => window.removeEventListener("sap:progress", f);
  }, []);
  return FILLABLE.filter((t) => started.includes(t.id)).length;
};
